export const systemConfig = {
  degrees: {
    name: 'degrees',
    size: 3000,
    page: 1,
    autoCorrect: true,
    q: '',
    removeSpecialChars: true,
    filters: [
      {
        field: 'status.keyword',
        value: '1',
      },
    ],
  },
  streams: {
    name: 'streams',
    size: 3000,
    page: 1,
    autoCorrect: true,
    removeSpecialChars: true,
    filters: [
      {
        field: 'status.keyword',
        value: '1',
      },
    ],
  },
  degree_streams: {
    name: 'degree_streams',
    size: 3000,
    page: 1,
    autoCorrect: false,
    removeSpecialChars: true,
    childSize: 1000,
    filters: [
      {
        field: 'status.keyword',
        value: '1',
      },
    ],
  },
  specialisations: {
    name: 'specialisations',
    size: 3000,
    page: 1,
    autoCorrect: true,
    removeSpecialChars: true,
    filters: [
      {
        field: 'status.keyword',
        value: '1',
      },
    ],
  },
  institutesCampuses: {
    name: 'institutes_campuses',
    size: 3000,
    page: 1,
    autoCorrect: true,
    removeSpecialChars: true,
    filters: [
      {
        field: 'instituteIsActive.keyword',
        value: true,
      },
    ],
  },
  universities: {
    name: 'universities',
    size: 3000,
    page: 1,
    autoCorrect: true,
    removeSpecialChars: true,
    filters: [
      {
        field: 'status.keyword',
        value: '1',
      },
    ],
  },
  skills: {
    name: 'skills',
    size: 10000,
    page: 1,
    q: '',
    autoCorrect: true,
    removeSpecialChars: true,
    filters: [
      {
        field: 'status.keyword',
        value: '1',
      },
    ],
  },
  function: {
    name: 'function',
    size: 10,
    page: 1,
    autoCorrect: true,
    removeSpecialChars: true,
    filters: [
      {
        field: 'isActive',
        value: true,
      },
    ],
  },
  industries: {
    name: 'industries',
    size: 3000,
    page: 1,
    autoCorrect: true,
    removeSpecialChars: true,
    filters: [
      {
        field: 'isActive',
        value: true,
      },
    ],
  },
  courses: {
    name: 'degree_streams_specialisation',
    size: 3000,
    page: 1,
    autoCorrect: true,
    removeSpecialChars: true,
    childSize: 1000,
    searchType: 'ALL',
    filters: [
      // {
      //   field: 'type.keyword',
      //   value: 'PG',
      // },
      // {
      //   field: 'type.keyword',
      //   value: 'UG',
      // },

      // {
      //   field: 'status.keyword',
      //   value: '1',
      // },
    ],
    q: '',
    should: [],
  },
  degree_streams_specialisation: {
    name: 'degree_streams_specialisation',
    size: 3000,
    page: 1,
    autoCorrect: true,
    removeSpecialChars: true,
    childSize: 1000,
    searchType: 'ALL',
    filters: [],
  },
}
